import React from 'react'
import { getImages } from '../../Common/const'

const WorkBrand = () => {
    return (
        <>
            <section className='work-brand-wrap d-lg-flex align-items-center'>
                <div className='wb-left d-lg-flex wow reveal fadeInLeft'>
                    <div className='mxw-650 ms-lg-auto'>
                        <h3 className='lg-title mb-lg-5 mb-4'>We work on all the top brands</h3>
                        <div className='d-flex align-items-center flex-wrap wb-logos-flex'>
                            <div className='w-25 my-3 brand-icon'>
                                <img src={getImages('koenigsegg.png')} />
                            </div>
                            <div className='w-25 my-3 brand-icon'>
                                <img src={getImages('lamborghini.png')} />
                            </div>
                            <div className='w-25 my-3 brand-icon'>
                                <img src={getImages('rolls-royce.png')} />
                            </div>
                            <div className='w-25 my-3 brand-icon'>
                                <img src={getImages('maserati.png')} />
                            </div>
                            <div className='w-25 my-3 brand-icon'>
                                <img src={getImages('porsche.png')} />
                            </div>
                            <div className='w-25 my-3 brand-icon'>
                                <img src={getImages('ferrari.png')} />
                            </div>
                            <div className='w-25 my-3 brand-icon'>
                                <img src={getImages('mclaren.png')} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='wb-right wow reveal fadeInRight'>
                    <img src={getImages('work-brand-image.png')} alt='work brand' />
                </div>
            </section>
        </>
    )
}

export default WorkBrand